import { inject, Injectable } from '@angular/core';

import postscribe from 'postscribe';

import { BaasAppState } from '@lvflanders/bar';

interface ClassicWidgetsConfig {
    widgetUrl: string;
    headerWidgetId: string;
    footerWidgetId: string;
}

// NOTE this will be used in disconnected modus (Polaris) or if config is missing
const DEFAULT_WIDGETS_CONFIG: ClassicWidgetsConfig = {
    widgetUrl: '//widgets.vlaanderen.be/widget/live/{widgetId}',
    headerWidgetId: '1ebe22634f1d4cc2b4c5a05de8f78d0c',
    footerWidgetId: '6a87cf7f6e8d443187a349c7ccc0a794'
};

@Injectable()
export class _BarClassicWidgetsEngine {
    readonly #state = inject(BaasAppState, { optional: true });

    get #config(): ClassicWidgetsConfig {
        return <ClassicWidgetsConfig>this.#state?.config?.baasStatic?.classicWidgets || DEFAULT_WIDGETS_CONFIG;
    }

    tryMountHeader(element: HTMLElement): boolean {
        // only mount if online (avoid errors SPOT offline)
        if (navigator.onLine) {
            const url = this.#config.widgetUrl.replace('{widgetId}', this.#config.headerWidgetId);
            postscribe(element, `<script src=${url}></script>`);
            return true;
        }
        return false;
    }
    tryMountFooter(element: HTMLElement): boolean {
        // only mount if online (avoid errors SPOT offline)
        if (navigator.onLine) {
            const url = this.#config.widgetUrl.replace('{widgetId}', this.#config.footerWidgetId);
            postscribe(element, `<script src=${url}></script>`);
            return true;
        }
        return false;
    }
}
